<template>
  <div class="page">
    <CertFile :comp="comp" />
  </div>
</template>

<script setup lang="ts">
// 电子证书下载
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import CertFile from '@/components/certFile.vue';

const route = useRoute();
const comp = ref(getTopPathSegment(route.path));

function getTopPathSegment(path: string) {
  const parts = String(path || '')
    .split('?')[0]
    .split('/')
    .filter(Boolean);
  return parts[0] || '';
}

const syncCompFromRoute = () => {
  const href = window.location.href;
  const parts = String(route.path || '')
    .split('?')[0]
    .split('/')
    .filter(Boolean);
  const top = parts[0] || '';
  console.log(href);
  console.log(parts);
  console.log(top);
  if (top) {
    comp.value = top;
  }
  return top;
};

onMounted(() => {
  syncCompFromRoute();
});

watch(
  () => route.fullPath,
  () => {
    syncCompFromRoute();
  }
);
</script>

<style scoped>
.page {
  padding: 20px;
}
</style>
